/**
 * This is a React component that displays a prompt to repeat previous product variations or choose new
 * ones, and triggers certain actions based on user input.
 * @returns The component `RepeatVariation` is being returned.
 */
import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addToCartForRepeatPreviousSelectedVariations } from "../../../State/actions/productActions";
import {
  RELATEABLE_DIV_SHOW_ON_QUICKVIEW, ReactProjectBaseUrl
} from "../../../utils/Constants";
import { axiosFunction } from "../../../utils/globalFunctions/axiosFunction";
import PrimaryButton from "../../PrimaryButton";
import { API_ENDPOINTS } from "../../../utils/api-endpoints";
import { globalSwalFunction } from "../../../utils/globalFunctions/globalSwal";

const RepeatVariation = ({
  id,
  relatedDiv,
  setRelatedDiv,
  productVarient,
  varientIndex,
  triggerQuickViewModal,
}) => {
  const dispatch = useDispatch();

  const addToCartForRepeatPreviousSelectedVariationsWrapperFnc = async (
    productid,
  ) => {
      dispatch(addToCartForRepeatPreviousSelectedVariations(productid));
  };

  /* `const handleOnclick` is a function that is created using the `useCallback` hook. It sets the
`relatedDiv` state to `RELATEABLE_DIV_SHOW_ON_QUICKVIEW.ADD_PRODUCT_VARIANTS` and triggers the
`triggerQuickViewModal` function with the arguments "open" and `id`. The `useCallback` hook is used
to memoize the function and optimize performance by only recreating the function if any of the
dependencies (`setRelatedDiv`, `triggerQuickViewModal`, `id`) have changed. */
  const handleOnclick = useCallback(() => {
    setRelatedDiv(RELATEABLE_DIV_SHOW_ON_QUICKVIEW.ADD_PRODUCT_VARIANTS);
    triggerQuickViewModal("open", id);
  }, [setRelatedDiv, triggerQuickViewModal, id]);

  useEffect(()=> {
    handleOnclick()
  },[])

  return null
  // return (
  //   <>
  //     {relatedDiv == RELATEABLE_DIV_SHOW_ON_QUICKVIEW.REPEAT_LAST_VARINATS && (
  //       <div className="repeateSelectedLastVaraint">
  //         <div className="mb-3 p-3">
  //           <h1 style={{ fontWeight: 600 }}>Repeat previous selection?</h1>
  //           <small>You have multiple customizations for Current Product.</small>
  //         </div>
  //         <div className="d-flex justify-content-center">
  //           <PrimaryButton
  //             id={"variantProductChoose"}
  //             className="button button_addToCard_inverted"
  //             style={{ marginRight: "5px" }}
  //             onClick={() => handleOnclick()}
  //             name={"I'll Choose"}
  //           />
  //           <PrimaryButton
  //             id={"variantProductChoose"}
  //             className="button button_addToCard"
  //             onClick={async () => {
  //               await addToCartForRepeatPreviousSelectedVariationsWrapperFnc(
  //                 productVarient[varientIndex].productid
  //               );
  //               triggerQuickViewModal("close");
  //             }}
  //             name={"Repeat"}
  //           />
  //         </div>
  //       </div>
  //     )}
  //   </>
  // );
};

export default RepeatVariation;
